function updateDelayedText(variant) {
    const previousText = document.querySelector(".delay-text.is-visible");
    const newText = document.querySelector(`.delay-text[data-variant-id="${variant.id}"]`);
    if(previousText) {
        previousText.classList.remove("is-visible");
    }
    if(newText) {
        newText.classList.add("is-visible");
    }
}


// document.addEventListener('DOMContentLoaded', function(){

//   let collectitem = [];

//   let menuitem = document.querySelectorAll('.mega-menu .mega-menu-columns .dropdown-submenu p.menuitem');
 
//   menuitem.forEach(item => {
//     collectitem.push(item.textContent.trim());
//   });

//   console.log(collectitem); 
// });




